import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=7289d5b8&scoped=true&"
import script from "./Matching.vue?vue&type=script&lang=js&"
export * from "./Matching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7289d5b8",
  null
  
)

export default component.exports